import {
  FaTools,
  FaLightbulb,
  FaHandsHelping,
  FaCheckCircle,
  FaClock,
  FaDraftingCompass,
  FaUserFriends,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaHome,
  FaBuilding,
  FaBrain,
  FaSimplybuilt,
  FaBandcamp,
  FaCreativeCommonsSa,
} from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";
import {
  blog1,
  blog2,
  blog3,
  member1,
  member2,
  member3,
  member4,
  member5,
  member6,
  mem1,
  mem2,
  mem3,
  newP1,
  newP2,
  newP3,
  newP4,
  newP5,
  newP6,
  portfolio2,
  portfolio3,
  portfolio4,
  portfolio5,
  portfolio6,
  user1,
  user2,
  user3,
  user4,
} from "./assets";

export const navigations = [
  {
    label: "About Us",
    to: "about",
  },
  {
    label: "Services",
    to: "services",
  },
  {
    label: "Portfolio",
    to: "portfolio",
  },
  {
    label: "Team",
    to: "team",
  },
  {
    label: "Testimonials",
    to: "testimonials",
  },
  {
    label: "Contact Us",
    to: "contact",
  },
];

export const keypoints = [
  {
    icon: <FaTools />,
    title: "Expert Craftsmanship",
  },
  {
    icon: <FaRegClock />,
    title: "On-Time, Within Budget",
  },
  {
    icon: <FaLightbulb />,
    title: "Innovative Solutions",
  },
  {
    icon: <FaHandsHelping />,
    title: "Client-Centered Approach",
  },
  {
    icon: <FaBrain />,
    title: "Premium Quality Standards",
  },
  {
    icon: <FaSimplybuilt />,
    title: "Reliable Project Management",
  },
  {
    icon: <FaCreativeCommonsSa />,
    title: "Built on Trust & Integrity",
  },
  {
    icon: <FaBandcamp />,
    title: "Unmatched Expertise",
  },
];

export const whyChooseUs = [
  {
    title: "Unmatched Quality",
    icon: <FaCheckCircle />,
    description: "Craftsmanship guaranteed",
  },
  {
    title: "Timely Delivery",
    icon: <FaClock />,
    description: "Projects completed on schedule",
  },
  {
    title: "Innovative Designs",
    icon: <FaDraftingCompass />,
    description: "Creative and modern solutions",
  },
  {
    title: "Focused Service",
    icon: <FaUserFriends />,
    description: "Prioritizing client satisfaction always",
  },
];

export const services = [
  {
    title: "Residential Construction",
    icon: <FaHome />,
    description: `Building modern, high-quality homes tailored to your vision.`,
  },
  {
    title: "Commercial Projects",
    icon: <FaBuilding />,
    description: `Developing functional, innovative commercial spaces for businesses.`,
  },
  {
    title: "Renovation & Remodeling",
    icon: <FaTools />,
    description: `Transforming existing spaces with expert renovation and design.`,
  },
];

export const portfolio = [
  {
    title: "Luxury Residential Home",
    image: newP1,
    date: "May 15, 2023",
    category: "Residential",
    description: `An elegant luxury estate showcasing timeless architecture, premium stone finishes, and grand entrance detailing. Designed to deliver exceptional comfort and sophistication, this residence reflects the highest standards of craftsmanship and modern luxury.`,
  },
  {
    title: "Contemporary Urban Villa",
    image: newP2,
    date: "November 30, 2022",
    category: "Residential",
    description: `A sleek contemporary villa featuring bold geometric architecture, natural wood accents, and expansive living spaces. This home seamlessly blends modern aesthetics with functionality, creating an inviting environment for everyday living.`,
  },
  {
    title: "Twin Luxury Residences",
    image: newP3,
    date: "July 12, 2024",
    category: "Residential",
    description: `A beautifully designed dual-residence project offering contemporary architecture, premium finishes, and balanced symmetry. Built to maximize style, comfort, and functionality, these homes provide refined living for modern families.`,
  },
  {
    title: "Modern Executive Residencea",
    image: newP4,
    date: "February 1, 2023",
    category: "Residential",
    description: `A striking executive home featuring clean architectural lines, premium materials, and thoughtfully designed living spaces. Every detail has been crafted to provide elegance, efficiency, and lasting value for modern homeowners.`,
  },
  {
    title: "Classic Family Villa",
    image: newP5,
    date: "September 18, 2023",
    category: "Residential",
    description: `A beautifully crafted family villa that combines timeless architectural charm with modern comforts. Spacious interiors, elegant detailing, and high-quality finishes create a warm and welcoming home built to stand the test of time.`,
  },
  {
    title: "Signature Modern Home",
    image: newP6,
    date: "March 5, 2022",
    category: "Residential",
    description: `A sophisticated contemporary residence designed with minimalist architecture, expansive glass features, and premium exterior finishes. This project embodies innovation, quality craftsmanship, and luxurious everyday living.`,
  },
];

export const teamMembers = [
  {
    fullName: "Mr. Mirza Usman",
    image: mem1,
    title: "CEO",
    socialMedias: [
      { name: "Facebook", icon: <FaFacebook />, href: "http://facebook.com" },
      { name: "LinkedIn", icon: <FaLinkedin />, href: "http://linkedin.com" },
      {
        name: "Youtube",
        icon: <FaYoutube />,
        href: "https://www.youtube.com",
      },
      {
        name: "Instagram",
        icon: <FaInstagram />,
        href: "http://instagram.com",
      },
    ],
  },
  {
    fullName: "Mr. Haji Shareef sb",
    image: mem2,
    title: "Founder",
    socialMedias: [
      { name: "Facebook", icon: <FaFacebook />, href: "http://facebook.com" },
      { name: "LinkedIn", icon: <FaLinkedin />, href: "http://linkedin.com" },
      {
        name: "Youtube",
        icon: <FaYoutube />,
        href: "https://www.youtube.com",
      },
      {
        name: "Instagram",
        icon: <FaInstagram />,
        href: "http://instagram.com",
      },
    ],
  },
  {
    fullName: "Mr. Ashfaq sb",
    image: mem3,
    title: "Chairman",
    socialMedias: [
      { name: "Facebook", icon: <FaFacebook />, href: "http://facebook.com" },
      { name: "LinkedIn", icon: <FaLinkedin />, href: "http://linkedin.com" },
      {
        name: "Youtube",
        icon: <FaYoutube />,
        href: "https://www.youtube.com",
      },
      {
        name: "Instagram",
        icon: <FaInstagram />,
        href: "http://instagram.com",
      },
    ],
  },
  // {
  //   fullName: "Ngozi Eze",
  //   image: member4,
  //   title: "Construction Planner",
  //   socialMedias: [
  //     { name: "Facebook", icon: <FaFacebook />, href: "http://facebook.com" },
  //     { name: "LinkedIn", icon: <FaLinkedin />, href: "http://linkedin.com" },
  //     {
  //       name: "Youtube",
  //       icon: <FaYoutube />,
  //       href: "https://www.youtube.com/channel/UCEtnsPZQEd0l1tbr_nDQd5Q?sub_confirmation=1",
  //     },
  //     {
  //       name: "Instagram",
  //       icon: <FaInstagram />,
  //       href: "http://instagram.com",
  //     },
  //   ],
  // },
  // {
  //   fullName: "Tunde Afolabi",
  //   image: member5,
  //   title: "Site Supervisor",
  //   socialMedias: [
  //     { name: "Facebook", icon: <FaFacebook />, href: "http://facebook.com" },
  //     { name: "LinkedIn", icon: <FaLinkedin />, href: "http://linkedin.com" },
  //     {
  //       name: "Youtube",
  //       icon: <FaYoutube />,
  //       href: "https://www.youtube.com/channel/UCEtnsPZQEd0l1tbr_nDQd5Q?sub_confirmation=1",
  //     },
  //     {
  //       name: "Instagram",
  //       icon: <FaInstagram />,
  //       href: "http://instagram.com",
  //     },
  //   ],
  // },
  // {
  //   fullName: "Sonia Olufemi",
  //   image: member6,
  //   title: "Design Coordinator",
  //   socialMedias: [
  //     { name: "Facebook", icon: <FaFacebook />, href: "http://facebook.com" },
  //     { name: "LinkedIn", icon: <FaLinkedin />, href: "http://linkedin.com" },
  //     {
  //       name: "Youtube",
  //       icon: <FaYoutube />,
  //       href: "https://www.youtube.com/channel/UCEtnsPZQEd0l1tbr_nDQd5Q?sub_confirmation=1",
  //     },
  //     {
  //       name: "Instagram",
  //       icon: <FaInstagram />,
  //       href: "http://instagram.com",
  //     },
  //   ],
  // },
];

export const testimonials = [
  {
    name: "Folake Adekunle",
    image: user1,
    review: `The team at Confix exceeded our expectations. Their attention to detail and professionalism made our home renovation a smooth and enjoyable process.`,
  },
  {
    name: "Jide Akinwale",
    image: user2,
    review: `From start to finish, the project was handled with incredible skill and efficiency. I highly recommend Confix for any construction needs.`,
  },
  {
    name: "Chiamaka Nwachukwu",
    image: user3,
    review: `Working with Confix was a fantastic experience. Their team was professional, creative, and committed to delivering exactly what we envisioned.`,
  },
  {
    name: "Tunde Balogun",
    image: user4,
    review: `Exceptional service and quality workmanship! Confix transformed our industrial space efficiently and effectively. They are true professionals.`,
  },
];

export const blogs = [
  {
    title: "Innovative Construction Trends for 2024",
    content: `Discover the latest trends in construction for 2024, from sustainable building practices to cutting-edge technologies transforming the industry.`,
    image: blog1,
  },
  {
    title: "The Importance of Sustainable Building Materials",
    content: `Learn why using sustainable building materials is crucial for environmental protection and how it benefits both the project and the community.`,
    image: blog2,
  },
  {
    title: "Top Tips for Effective Project Management",
    content: `Explore essential tips for managing construction projects efficiently, including scheduling, budgeting, and communication strategies.`,
    image: blog3,
  },
];

export const footer = [
  {
    title: "Company",
    routes: [
      {
        name: "About Us",
        href: "#",
      },
      {
        name: "Our Team",
        href: "#",
      },
      {
        name: "Careers",
        href: "#",
      },
      {
        name: "Contact Us",
        href: "#",
      },
    ],
  },
  {
    title: "Services",
    routes: [
      {
        name: "Residential Construction",
        href: "#",
      },
      {
        name: "Commercial Projects",
        href: "#",
      },
      {
        name: "Renovation & Remodeling",
        href: "#",
      },
      {
        name: "Project Management",
        href: "#",
      },
    ],
  },
  {
    title: "Resources",
    routes: [
      {
        name: "Blog",
        href: "#",
      },
      {
        name: "Case Studies",
        href: "#",
      },
      {
        name: "FAQs",
        href: "#",
      },
      {
        name: "Privacy Policy",
        href: "#",
      },
    ],
  },
];

export const socialHandles = [
  {
    name: "Facebook",
    icon: <FaFacebook />,
    link: "https://www.facebook.com",
  },
  {
    name: "Instagram",
    icon: <FaInstagram />,
    link: "https://www.instagram.com",
  },
  {
    name: "LinkedIn",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com",
  },
  {
    name: "Youtube",
    icon: <FaYoutube />,
    link: "https://www.youtube.com/channel/UCEtnsPZQEd0l1tbr_nDQd5Q?sub_confirmation=1",
  },
];
